module.exports = __webpack_public_path__ + "static/media/tafe.ad9a2331.jpg";